import request from '../untils/request';

export const paymentListApi = params => {
  return request({
    url: '/operation/payment/index',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};

export const paymentStatusApi = params => {
  return request({
    url: '/operation/payment/status',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};

export const paymentRecommendApi = params => {
  return request({
    url: '/operation/payment/recommend',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};

export const paymentHideApi = params => {
  return request({
    url: '/operation/payment/hide',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};

export const paymentSaveApi = params => {
  return request({
    url: '/operation/payment/save',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};

export const paymentMchApi = params => {
  return request({
    url: '/operation/payment/mch',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};

export const paymentMchStatusApi = params => {
  return request({
    url: '/operation/payment/mch-status',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};

export const paymentWeightApi = params => {
  return request({
    url: '/operation/payment/weight',
    authCode: 'PAYMENT_INDEX',
    params,
  });
};
